import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/inventory-kits/profile/loading';

export const Route = createFileRoute('/_private/settings/inventory-kits/$id')({
  pendingComponent: Loading,
});
